import React from 'react';
import Image from 'next/image';

interface TravelImage {
  Image: { url: string }[];
}
interface TravelImagesProps {
  travelImages: TravelImage[];
}

const TravelImages: React.FC<TravelImagesProps> = ({ travelImages }) => {
  const [imagesLoaded, setImagesLoaded] = React.useState({
    tour1: false,
    tour2: false,
    tour3: false
  });

  const handleImageLoad = (id: string) => {
    setImagesLoaded(prev => ({
      ...prev,
      [id]: true
    }));
  };

  return (
    <div className="relative w-full max-w-6xl mx-auto px-4 py-8 mt-10">
      <div className="flex justify-center items-center">
        <div className="relative flex justify-center items-center">
          <div
            className="relative z-20 transform -rotate-6 transition-all duration-300
                         w-[110px] xs:w-[160px] sm:w-[180px] md:w-[220px] lg:w-[310px]
                         h-[140px] xs:h-[210px] sm:h-[240px] md:h-[300px] lg:h-[380px]
                         -mr-8 xs:-mr-10 sm:-mr-16 md:-mr-[1rem] lg:-mr-[1rem]
                         -top-8 lg:-top-24"
          >
            <div className="relative w-full h-full">
              <Image
                src={
                  travelImages
                    ? travelImages[0]?.Image[0]?.url
                    : '/placeholder.webp'
                }
                alt="Tour Image 1"
                className="rounded-lg shadow-lg object-cover w-full h-full"
                width={350}
                height={350}
                onLoad={() => handleImageLoad('tour1')}
                loading="lazy"
                placeholder="blur"
                blurDataURL="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MDAiIGhlaWdodD0iNDAwIiB2aWV3Qm94PSIwIDAgNDAwIDQwMCI+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0iI2YyZjJmMiIvPjwvc3ZnPg=="
              />
              <div
                className="absolute left-0 top-[30%] h-[70%] bg-red-500
                            w-2 sm:w-3 md:w-[18px] lg:w-[22px]"
                style={{
                  clipPath: 'polygon(0% 0%, 40% 0%, 80% 100%, 0% 100%)'
                }}
              ></div>

              <div
                className="absolute left-0 lg:-bottom-2 bg-red-500 rotate-0.5[deg] w-[60%]
                            h-1 sm:h-1.5 md:h-2 lg:h-2.5"
                style={{
                  clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)'
                }}
              ></div>
            </div>
          </div>

          <div
            className="relative z-10 transform transition-all duration-300
                         w-[110px] xs:w-[140px] sm:w-[160px] md:w-[210px] lg:w-[290px]
                         h-[140px] xs:h-[190px] sm:h-[220px] md:h-[280px] lg:h-[350px]
                         top-4 sm:top-6"
          >
            <div className="relative w-full h-full">
              <Image
                src={
                  travelImages
                    ? travelImages[1]?.Image[0]?.url
                    : '/placeholder.webp'
                }
                alt="Tour Image 2"
                className="rounded-lg shadow-xl object-cover w-full h-full"
                width={450}
                height={350}
                onLoad={() => handleImageLoad('tour2')}
                loading="lazy"
                placeholder="blur"
                blurDataURL="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MDAiIGhlaWdodD0iNDAwIiB2aWV3Qm94PSIwIDAgNDAwIDQwMCI+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0iI2YyZjJmMiIvPjwvc3ZnPg=="
              />
              <div
                className="absolute left-[15%] lg:-bottom-3 bg-red-500 w-[80%]
                            h-1.5 sm:h-2 md:h-3 lg:h-4"
                style={{
                  clipPath: 'polygon(50% 0%, 100% 0%, 100% 100%, 0% 10%)'
                }}
              ></div>
            </div>
          </div>

          <div
            className="relative z-0 transform rotate-6 transition-all duration-300
                         w-[110px] xs:w-[160px] sm:w-[180px] md:w-[220px] lg:w-[310px]
                         h-[140px] xs:h-[210px] sm:h-[240px] md:h-[300px] lg:h-[380px]
                         -ml-8 xs:-ml-10 sm:-ml-16 md:-ml-[2rem] lg:-ml-[2rem]
                         -top-8 lg:-top-24"
          >
            <div className="relative w-full h-full">
              <Image
                src={
                  travelImages
                    ? travelImages[2]?.Image[0]?.url
                    : '/placeholder.webp'
                }
                alt="Tour Image 3"
                className="rounded-lg shadow-lg object-cover w-full h-full"
                width={450}
                height={350}
                onLoad={() => handleImageLoad('tour3')}
                loading="lazy"
                placeholder="blur"
                blurDataURL="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MDAiIGhlaWdodD0iNDAwIiB2aWV3Qm94PSIwIDAgNDAwIDQwMCI+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0iI2YyZjJmMiIvPjwvc3ZnPg=="
              />
              <div
                className="absolute -right-1 md:-right-2 lg:-right-[10px] top-[20%] h-[70%] bg-red-500 -rotate-2
                            w-[7px] sm:w-[7px] md:w-[13px] lg:w-4"
                style={{
                  clipPath: 'polygon(50% 0%, 100% 0%, 100% 100%, 0% 100%)'
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TravelImages;
